import React, { useContext, useEffect, useState } from 'react'
import { ButtonsDiv, CloseDiv, CloseImg, Container, CreateButtonDiv, CreateButtonImage, CreateButtonText, ErrorMessage, HeaderDiv, HeaderText, InputDiv, InputProfileName, LabelCreate, TipText } from './style'
import cross from '../../assets/addStockModal/cross.svg'
import plus from '../../assets/headers/plus.svg'
import ModalContext from '../../contexts/ModalContext'
import axios from 'axios'
import UserContext from '../../contexts/UserContext'
import { useProfileContext } from '../../contexts/AccessesContext'

const CreateProfile:React.FC = () => {

  const [ profileName, setProfileName ] = useState('')
  const { setModalActive } = useContext(ModalContext)
  const { token } = useContext(UserContext)
  const { newProfiles, setNewProfiles } = useProfileContext()
  const [correctName, setCorrectName] = useState(false)
  const [click, setClick] = useState(false)
  const [error, setError] = useState(false)

  interface CreateProfileData {
    name:string
  }

  useEffect(() => {
    profileName.trim()
    if(profileName.length <= 2){
      setCorrectName(false)
    }else{
      setCorrectName(true)
    }
  }, [profileName])

  const createProfile = async(profile:string) => {
    const data:CreateProfileData = {
      name: profile
    }
    try{
      await axios.post(`${process.env.REACT_APP_BASE_URL}/profile`, data,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      setNewProfiles(() => newProfiles+1)
      setModalActive(false)
    }catch(error:any){
      if(error.response.status === 409){
        setError(true)
      }
      console.error('Erro ao criar perfil',error)
    }
  }
  
  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Criar novo</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
            <CloseImg src={cross} alt='Close tab'/>
        </CloseDiv>
      </HeaderDiv>
      <InputDiv>
        <LabelCreate>Insira o nome do perfil</LabelCreate>
        {error ? <ErrorMessage>Pefil com este nome já existente</ErrorMessage> : null}
        <InputProfileName 
          placeholder='Digite aqui'
          type='text'
          onChange={(event) => setProfileName(event.target.value)}
          value={profileName}
        />
      </InputDiv>
      <ButtonsDiv>
        {!correctName ? (
          <>
          {click ? (
            <TipText>Deve conter pelo menos 3 letras</TipText>
          ) : null}
          <CreateButtonDiv onClick={() => setClick(true)}>
            <CreateButtonImage src={plus} alt='Plus icon'/>
            <CreateButtonText>Criar perfil</CreateButtonText>
          </CreateButtonDiv>
          </>
        ) : (
          <CreateButtonDiv onClick={() => createProfile(profileName)}>
            <CreateButtonImage src={plus} alt='Plus icon'/>
            <CreateButtonText>Criar perfil</CreateButtonText>
          </CreateButtonDiv>
        )}
      </ButtonsDiv>
    </Container>
  )
}

export default CreateProfile